var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg98(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25H9V6.75H2.25V5.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.75H9V17.25H2.25V15.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.5H4.5V12H2.25V10.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 11.1075C20.9737 10.9723 20.9109 10.8469 20.8183 10.7451C20.7257 10.6432 20.6068 10.5688 20.4748 10.53L15.4573 9.08998L16.6273 4.43998C16.6646 4.28819 16.6536 4.12853 16.5958 3.9833C16.538 3.83808 16.4362 3.71455 16.3048 3.62998C16.1785 3.54122 16.0279 3.49359 15.8735 3.49359C15.7192 3.49359 15.5686 3.54122 15.4423 3.62998L6.29226 10.6575C6.17427 10.7399 6.08248 10.8545 6.02784 10.9876C5.9732 11.1208 5.95802 11.2668 5.98411 11.4083C6.0102 11.5499 6.07646 11.6809 6.17499 11.7858C6.27351 11.8907 6.40014 11.9651 6.53976 12L11.5573 13.44L10.3873 18.09C10.3499 18.2418 10.3609 18.4014 10.4187 18.5466C10.4765 18.6919 10.5783 18.8154 10.7098 18.9C10.8361 18.9887 10.9867 19.0364 11.141 19.0364C11.2954 19.0364 11.446 18.9887 11.5723 18.9L20.7073 11.9025C20.8305 11.8149 20.9243 11.6921 20.9765 11.5502C21.0287 11.4084 21.0368 11.254 20.9998 11.1075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg98);
export default __webpack_public_path__ + "static/media/svg98.e5ea9ea145918c0cbbe74519cea1a93d.svg";
export { ForwardRef as ReactComponent };